import * as React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TerritoryAssignment } from '../../../domain/TerritoryAssignment';
import { withLazyMounting } from '../../../components/hoc/LazyDialog';

interface Props {
    assignment: TerritoryAssignment;
    isOpen: boolean;
    onClose: () => void;
    onSave: (notes: string) => void;
}

const ShowTerritoryPublisherNotesDialog = ({ assignment, isOpen, onClose, onSave }: Props) => {
    const { t } = useTranslation();
    const [value, setValue] = React.useState<string>(assignment?.publisherNotes || '');

    React.useEffect(() => {
        setValue(assignment?.publisherNotes || '');
    }, [assignment]);

    const handleSave = () => {
        onSave(value);
    };

    return (
        <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>{t('publisher_notes')}</DialogTitle>
            <br />
            <DialogContent>
                <TextField
                    value={value}
                    onChange={(event) => setValue(event.target.value)}
                    fullWidth
                    multiline
                    minRows={4}
                    label={t('publisher_notes')}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('cancel')}</Button>
                <Button onClick={handleSave}>{t('save')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default withLazyMounting(ShowTerritoryPublisherNotesDialog);
